import {
  ErrorCodes,
  ErrorMessages,
  ErrorStatuses,
  IdSchemaEnum,
} from "../../../../enums";
import { SDKConfiguraitonModel } from "../../../../models";
import { IdSchemaType, OddClientConfig } from "../../../Configurator/Types/ConfiguratorTypes";
import BaseValidator from "../../../Global/Validator/BaseValidator";
import Sportal365Https from "../../../Https/Sportal365Https";
import IdMappingService from "../../../IdMapping/IdMappingService";
import MatchOddsFilters from "../Models/Filters/MatchOddsFilters";
import MatchOddsModel from "../Models/MatchOddsModel";

export default class OddsFacade {
  private readonly https: Sportal365Https;
  private readonly idSchema: IdSchemaType;
  private readonly oddClient: OddClientConfig;
  private readonly idMapping: IdMappingService = null;
  private readonly validator: BaseValidator;

  constructor(config: SDKConfiguraitonModel) {
    this.idSchema = config.idSchema;
    this.oddClient = config.oddClient;
    this.https = new Sportal365Https(config);
    this.validator = new BaseValidator(config.errorHandlingMode);
    this.idMapping = new IdMappingService(config);
  }

  public getByMatchIds = async (
    matchIds: string[],
    filters?: MatchOddsFilters
  ): Promise<Map<string, MatchOddsModel[]>> => {
    this.validateOddClient();

    if (!matchIds || !Array.isArray(matchIds) || matchIds.length === 0) {
      this.validator.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_MATCH_IDS,
        ErrorMessages.INVALID_MATCH_IDS
      );
    }

    let sportal365MatchIds = Array.from(matchIds);

    if (this.idSchema !== IdSchemaEnum.SPORTAL_365) {
      const idsObj = await this.idMapping.idMappingFacade.getEntitiesByIds(
        { match: Array.from(matchIds) },
        this.idSchema,
        IdSchemaEnum.SPORTAL_365
      );
      sportal365MatchIds = idsObj.match;
    }

    const finalFilters = new MatchOddsFilters(filters);
    const map = await this.https.getMatchOdds(sportal365MatchIds, finalFilters);

    if (this.idSchema !== IdSchemaEnum.SPORTAL_365) {
      const mapIds = await this.idMapping.idMappingFacade.getEntitiesByIdsMap(
        { match: Array.from(map.keys()) },
        IdSchemaEnum.SPORTAL_365,
        this.idSchema
      );
      const finalMap = new Map<string, MatchOddsModel[]>();
      Array.from(map.entries()).forEach(([key, value]) => {
        finalMap.set(mapIds.get(key), value);
      });

      return finalMap;
    }

    return map;
  };

  private validateOddClient = () => {
    if (!this.oddClient) {
      this.validator.throwException(
        ErrorCodes.PRECONDITION_FAILED,
        ErrorStatuses.ODD_CLIENT_CONFIGURATION_NOT_FOUND,
        ErrorMessages.MISSING_ODD_CLIENT_CONFIGURATION
      );
    }
  };
}
